import { graphql } from '@/gql/codegen/gql';
import type { SkillCheckTestQuestionAnswersInput } from '@/gql/codegen/graphql';
import { GET_USER_ATTENDANCE } from '@/routes/_embaUserLayout/user-attendances/$userAttendanceSlug/_lessonSideBarLayout';
import { useMutation } from '@apollo/client';
import { useNavigate } from '@tanstack/react-router';
import { useCallback, useState } from 'react';

export const ANSWER_SKILL_CHECK_TEST_MUTAION = graphql(/* GraphQL */ `
  mutation EmbaAnswerSkillCheckTestQuestions(
    $input: AnswerSkillCheckTestQuestionsMutationInput!
  ) {
    embaAnswerSkillCheckTestQuestions(input: $input) {
      success
    }
  }
`);

export const useAnswerSkillCheckTestMutation = (
  embaUserAttendanceSlug: string,
  embaUserCourseSkillCheckTestResultId: number | null,
) => {
  const [isSleeping, setIsSleeping] = useState(false);
  const navigate = useNavigate();
  const [
    answerSkillCheckTestMutation,
    {
      error: answerSkillCheckTestMutationError,
      loading: answerSkillCheckTestMutationLoading,
    },
  ] = useMutation(ANSWER_SKILL_CHECK_TEST_MUTAION, {
    refetchQueries: [
      {
        query: GET_USER_ATTENDANCE,
        variables: {
          embaUserAttendanceSlug: embaUserAttendanceSlug,
        },
      },
    ],
  });

  const answerSkillCheckTest = useCallback(
    async (
      answers: SkillCheckTestQuestionAnswersInput[],
      timeUp = false,
    ): Promise<void> => {
      if (!embaUserCourseSkillCheckTestResultId) {
        throw new Error(
          'embaUserCourseSkillCheckTestResultIdがセットされていません',
        );
      }

      await answerSkillCheckTestMutation({
        variables: {
          input: {
            embaUserAttendanceSlug,
            embaUserCourseSkillCheckTestResultId,
            answers,
          },
        },
      });
      setIsSleeping(true);

      // 回答時に非同期実行される修了証画像生成ロジックを考慮したスリープ
      setTimeout(() => {
        setIsSleeping(false);
        navigate({
          to: '/user-attendances/$userAttendanceSlug/skill-check-test/result',
          params: {
            userAttendanceSlug: embaUserAttendanceSlug,
          },
          search: {
            timeUp: timeUp,
            isAnswered: true,
          },
        });
      }, 1000);
    },
    [
      answerSkillCheckTestMutation,
      embaUserAttendanceSlug,
      embaUserCourseSkillCheckTestResultId,
      navigate,
    ],
  );

  return {
    answerSkillCheckTest,
    answerSkillCheckTestMutationError,
    answerSkillCheckTestMutationLoading:
      answerSkillCheckTestMutationLoading || isSleeping,
  };
};
